import { PHONETOOL_URL } from '../constants/grimsby';

/**
 * Method to get phonetool link for internal user
 * @return {string} Returns the link to phonetool page
 */
const getPhoneToolUrl = (alias: string): string => PHONETOOL_URL + alias;

export default getPhoneToolUrl;
